var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductionQuantityLimits = function SvgProductionQuantityLimits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "production_quantity_limits_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#production_quantity_limits_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 20q0-.824.588-1.413A1.93 1.93 0 0 1 7 18q.824 0 1.412.587Q9 19.176 9 20q0 .824-.588 1.413A1.93 1.93 0 0 1 7 22m10 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 15 20q0-.824.588-1.413A1.93 1.93 0 0 1 17 18q.824 0 1.413.587Q19 19.176 19 20q0 .824-.587 1.413A1.93 1.93 0 0 1 17 22M3 4H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 3q0-.424.288-.712A.97.97 0 0 1 2 2h1.65q.275 0 .525.15t.375.425L8.525 11h7l3.625-6.5a.85.85 0 0 1 .35-.375Q19.725 4 20 4q.574 0 .863.487a.94.94 0 0 1 .012.988L17.3 11.95q-.275.5-.738.775A1.95 1.95 0 0 1 15.55 13H8.1L7 15h11q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 18 17H7q-1.124 0-1.713-.975-.587-.975-.037-1.975L6.6 11.6zm9 5.5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 8.5q0-.424.287-.713A.97.97 0 0 1 12 7.5q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 12 9.5M12 6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 5V2q0-.424.287-.712A.97.97 0 0 1 12 1q.424 0 .713.288Q13 1.575 13 2v3q0 .424-.287.713A.97.97 0 0 1 12 6"
  }))));
};
export default SvgProductionQuantityLimits;